import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { ImageOff, Loader2, X } from "lucide-react";
import { Loading } from "../../lib/api";

export const PackagePhoto = ({ id, className = "w-16 h-16", testId }) => {
  const [url, setUrl] = useState(null);
  const [failed, setFailed] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    let objectUrl;
    let alive = true;
    setUrl(null); setFailed(false);
    Loading.photoBlob(id)
      .then((blob) => { objectUrl = URL.createObjectURL(blob); if (alive) setUrl(objectUrl); })
      .catch(() => alive && setFailed(true));
    return () => { alive = false; if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [id]);
  const box = `${className} shrink-0 rounded-xl overflow-hidden bg-zinc-100 ring-1 ring-zinc-200 flex items-center justify-center`;
  if (failed) return <div className={box} data-testid={testId}><ImageOff className="w-4 h-4 text-zinc-400" /></div>;
  if (!url) return <div className={box} data-testid={testId}><Loader2 className="w-4 h-4 animate-spin text-zinc-400" /></div>;
  return (
    <>
      <button type="button" data-testid={testId} onClick={(e) => { e.stopPropagation(); setOpen(true); }} onPointerDown={(e) => e.stopPropagation()} className={`${box} hover:ring-orange-400 transition-shadow`} title="Powiększ zdjęcie">
        <img src={url} alt="Zdjęcie paczki" className="w-full h-full object-cover" />
      </button>
      {open && createPortal(
        <div data-testid="package-photo-lightbox" onClick={() => setOpen(false)} className="fixed inset-0 z-[1500] bg-black/85 flex items-center justify-center p-4">
          <img src={url} alt="Zdjęcie paczki" className="max-w-full max-h-full rounded-xl" />
          <button type="button" data-testid="package-photo-close" className="absolute top-4 right-4 p-2 rounded-full bg-white/15 text-white hover:bg-white/30" aria-label="Zamknij"><X className="w-5 h-5" /></button>
        </div>, document.body)}
    </>
  );
};
